import Footer from './footer'
import FooterQuery from './footer.query'

export { FooterQuery }

export default Footer
